"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const assert = require("assert");
function parseOrderCancellation(tx) {
    assert(tx.TransactionType === 'OfferCancel');
    return {
        orderSequence: tx.OfferSequence
    };
}
exports.default = parseOrderCancellation;
//# sourceMappingURL=cancellation.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ripple-lib/dist/npm/ledger/parse/cancellation.js
// module id = 9W0w
// module chunks = 0